import { IconButton, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import PreviewIcon from '@mui/icons-material/Preview';

function ResponsePagePreview ({selectedDevice, setSelectedDevice, previewPage}) {

    return (
        <div style={{ width: "100%", textAlign: "end", paddingBottom: '10px' }}>
            <FormControl size="small">
                <InputLabel id="deviceInput">Device</InputLabel>
                <Select
                    labelId="deviceInput"
                    id="deviceSelect"
                    value={selectedDevice}
                    label="Device"
                    onChange={(e) => setSelectedDevice(e.target.value)}
                >
                    <MenuItem value={414}>IPhone 12/XR</MenuItem>
                    <MenuItem value={412}>Nexus 6P/5X, Google Pixel 1/2/3</MenuItem>
                    <MenuItem value={360}>Samsung Galaxy S7/S8/S9</MenuItem>
                    <MenuItem value={768}>iPad</MenuItem>
                </Select>
            </FormControl>

            <IconButton title="Preview" onClick={previewPage}>
                <PreviewIcon />
            </IconButton>      
        </div>
    )
}

export default ResponsePagePreview;